import { render, staticRenderFns } from "./consultManageAdd.vue?vue&type=template&id=4f8ab0ec&scoped=true&"
import script from "./consultManageAdd.vue?vue&type=script&lang=js&"
export * from "./consultManageAdd.vue?vue&type=script&lang=js&"
import style0 from "./consultManageAdd.vue?vue&type=style&index=0&id=4f8ab0ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ab0ec",
  null
  
)

export default component.exports